module.exports = __webpack_public_path__ + "static/media/lianghua.55235067.png";